import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowLoginContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { LoginProvider, UserAccountEvents } from './types';
import { Spectre } from '@/libraries/tracking';

import { useUserStore } from '@/stores/pinia/useUserStore';

import { computed } from 'vue';
import { storeToRefs } from 'pinia';

const { defineSpec, createSpecTracker, SpecType } = Spectre<SnowplowContext>(() => TrackingHelper.trackEvent);

const specs: typeof SpecType = {
	login: defineSpec<{
		property: `${string}_${string}` | string;
		label: string;
	}>()({
		action: UserAccountEvents.LOGIN,
	}),

	loginError: defineSpec<{
		property: LoginProvider;
		label: string;
	}>()({
		action: UserAccountEvents.LOGIN_ERROR,
	}),

	signUp: defineSpec<{
		property: `${string}_${string}` | string;
		label: string;
	}>()({
		action: UserAccountEvents.SIGNUP,
	}),

	signUpError: defineSpec<{
		property: LoginProvider;
		label: string;
	}>()({
		action: UserAccountEvents.SIGNUP_ERROR,
	}),

	dataProtectionSubmitted: {
		action: 'account_settings_submitted',
		label: 'data_protection',
		property: 'settings',
	},

	interestEmailsSubmitted: defineSpec<{ value: 1 | 0 }>()({
		action: 'account_settings_submitted',
		label: 'interest_emails',
		property: 'settings',
	}),
};

export function useAuthTracking() {
	const { jwLoginId } = storeToRefs(useUserStore());

	const loginContext = computed(() => (jwLoginId.value ? new SnowplowLoginContext(jwLoginId.value) : undefined));

	const trackAuth = createSpecTracker({
		specs,
		baseProperties: { category: 'user_account' },
		baseContexts: () => [loginContext.value],
	});

	return { trackAuth };
}
